export const HOSTING_URL = 'https://patient-consent.creativesad.com'

export const BASE_URL = 'https://consent-api.creativesad.com'

export const RECORD_PER_PAGE = 10;

export const personaHomePage: any = {
	Root: '/home',
	Admin: '/home',
	Coordinator: '/coordinator-home',
};


export const EMPTY_PATIENT_NAME_PLACEHODLER = 'Unkown'

export const EMPTY_SIGN_DATE_VALUE = 'Not signed yet'

export const SIGN_PALCEHOLDER = 'sign-placeholder.png'

export const DUPLICATE_EMAIL_ERROR_MESSAGE = 'Email already associated to another account'